export const getOffsetSeat = (
  seat: number,
  offset: number | undefined,
  maxPlayers: number,
): number => {
  if (offset === undefined) return seat
  return (seat + offset + maxPlayers) % maxPlayers
}
